import type { Locale } from "../api/types";
import { chromeLocale } from "../lib/locale-context";

/** Request-level messages shared by every screen (UX-01 §4.15; Thai provisional until the BMS PM confirms it). */
export type RequestTextKey = "inProgress";

export const REQUEST_TEXT: Record<Locale, Record<RequestTextKey, string>> = {
  en: {
    inProgress: "Your earlier request is still being saved. Nothing will be saved twice, so it is safe to try again in a moment.",
  },
  th: {
    inProgress: "คำขอก่อนหน้ายังบันทึกอยู่ ระบบจะไม่บันทึกซ้ำ จึงลองใหม่ได้อย่างปลอดภัยในอีกสักครู่",
  },
};

/** Request-status chrome is English-only regardless of the caller's locale (2026-09-17) — see `chromeLocale`. */
export function requestText(key: RequestTextKey, locale: Locale | undefined): string {
  return REQUEST_TEXT[chromeLocale(locale)][key];
}
